import App from '../../../vendor_core/core/src/App';
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import { Ease } from '../../../vendor_core/core/src/Ease';
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import BetModel from '../../../vendor_core/core/src/model/BetModel';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import ISpinData from '../../../vendor_core/core/src/server/data/ISpinData';
import GenericBigWinState from '../../../vendor_core/core/src/states/GenericBigWinState';
import { StateMachine } from '../../../vendor_core/core/src/states/StateMachine';
import { Tween } from '../../../vendor_core/core/src/Tween';
import BangUp from '../../../vendor_core/core/src/utils/BangUp';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import PromiseHelpers from '../../../vendor_core/core/src/utils/PromiseHelpers';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import { AbstractBitmapMoneyField } from '../../../vendor_core/core/src/views/AbstractBitmapMoneyField';
import { AbstractMoneyField } from '../../../vendor_core/core/src/views/AbstractMoneyField';
import SpineAnimation from '../../../vendor_core/core/src/views/SpineAnimation';
import IFantasmaConfig from '../../../vendor_core/src/server/data/IFantasmaConfig';
import GameSoundVars from '../enums/GameSoundVars';
import BackgroundHelper from '../view/background/BackgroundHelper';


export default class VOEBigWinState extends GenericBigWinState {
    private winMusic: Howl;
    private counWinSound: Howl;
    
    // True for Volatile Egypt (VOE), false for Safari Sun (SPS)
    private useCoinsSounds: boolean = false;
    protected anim: SpineAnimation;
    protected bwNames: string[] = [
        "bigwin_loop", 
        "superwin_loop", 
        "megawin_loop", 
        "epicwin_loop"
    ];

    public setBigWinConfig() {
      this.bigWinsDelayConfig = GameModel.gameConfig.bigWinsDelayConfig;
    }

    public async startBigWin() {

        let bwBitmapText = this.scene.sceneTextFields.get("win");
        const winMoney = this.scene.sceneMoneyFields.get("win_counter");

        bwBitmapText.visible = false;
        winMoney.visible = false;

        // In this game the big win sound must start before the actual animations.
        let bigWinDelay = 0;
        if (this.currentBigWinLevel == 0) {
            this.winMusic = SoundController.playSound(GameSoundVars.BIG_WIN, true);
            this.useCoinsSounds && SoundController.playSound(GameSoundVars.BIG_WIN_COINS, true);
            bigWinDelay = 0.5;
        }

        Tween.delayedCall(bigWinDelay, () => {
            ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open");
            this.backgroundScene = this.backgroundLayer.setScene("bigWin");
            this.anim = this.backgroundScene.spineAnimations.get("bigWin");
            this.playAnimation(this.bwNames[this.currentBigWinLevel]);
            this.bigWinAnimComplete = false;
            this.bwBitmapText = this.scene.sceneTextFields.get("win");
            this.bwBitmapText.text = "";
            this.playTransitionSound();
            let bangupEndVal = this.getSum();
            this.currentBangup = new BangUp();
            let bigWinDuration = this.bigWinsDelayConfig[this.bigWinScenes[this.currentBigWinLevel]].bigWinDuration;
            let bigWinBangupDuration = this.bigWinsDelayConfig[this.bigWinScenes[this.currentBigWinLevel]].bigWinBangupDuration;
             
            this.bigWinAnimDelayed = Tween.delayedCall(bigWinDuration, this.onBigWinAnimationComplete, [], this);
            winMoney.value = 0; 
            this.currentBangup.startBangup(this.bangUpVal, bangupEndVal, bigWinBangupDuration, {ease: Ease.None}, (val) => {
                this.bangUpVal = val;
                winMoney.value = this.bangUpVal;
                }, () => {
                    this.onBigWinBangupComplete();
                }
            );
            this.popupMoney(winMoney, bigWinBangupDuration);
            this._canExit = true;
            bwBitmapText.visible = true;
            winMoney.visible = true;
            
            this.counWinSound = SoundController.playSound(SoundVars.EFFECT_WINCOUNT, true);
        });
    }

    // add +1 on curentBigWinLevel related on BH-551
    protected getSum():number {
        let bangupEndVal = 0;
        if (this.maxBigWinLevel > this.currentBigWinLevel) {
            bangupEndVal = GameModel.gameConfig.bigWinRatioLevels[this.currentBigWinLevel + 1] * BetModel.totalBet;
        } else {
            bangupEndVal = SpinModel[this.spinModelProp];
        }
        return bangupEndVal;
    }

    private popupMoney(
        money: AbstractMoneyField | AbstractBitmapMoneyField, 
        duration: number
    ): Promise<boolean> {
        money.visible = true;
        let w = money.width;
        let h = money.height;
        let x = money.x;
        let y = money.y;
        return new Promise<boolean>((res) => {
            Tween.to(
                money,
                0.3,
                {
                    width: money.width * 1.3,
                    height: money.height * 1.3,
                    x: x - ((w * 1.3 - w) / 2),
                    yoyo: true,
                    repeat: 1,
                    onComplete: () => {
                        res(true);
                        this.startGrowUp(money, duration);
                    }
                }
            )
        })
    }

    private startGrowUp(
        money: AbstractMoneyField | AbstractBitmapMoneyField,
        duration: number) {
        //---------start banner grow up-------
        let w = money.width;
        let h = money.height;
        let x = money.x;
        let y = money.y;

        Tween.to(
            money,
            duration,
            {
                width: w * 1.1,
                height: h * 1.1,
                x: x - ((w * 1.1 - w) / 2),
                ease: Ease.None,
            }
        );
    }

    playCollectSound() {
        // do not delete
    }

    protected async onBigWinBangupComplete() {
        if(this.counWinSound) {
            SoundController.fadeStop(this.counWinSound, 0.5);
        }

        if(this.currentBigWinLevel == this.maxBigWinLevel || this.maxBigWinLevel == 0) {
            if(this.winMusic) {
                SoundController.fadeStop(this.winMusic, 1.0);
                this.winMusic = undefined;
            }

            this.useCoinsSounds && SoundController.stopSound(GameSoundVars.BIG_WIN_COINS);
            SoundController.playSound(SoundVars.BIG_WIN_COMPLETE);
        
        }
    }

    protected async onBigWinAnimationComplete() {
        if(!this.canExit()) {  // if skip was activated
            if(this.winMusic) {  // if onBigWinBangupComplete is not finished 
                this.onBigWinBangupComplete();
            }
        }

        if (this.skipped) {
            const winMoney = this.scene.sceneMoneyFields.get("win_counter");
            winMoney.value = this.getSum();
            await this.anim.playAsync(this.bwNames[this.maxBigWinLevel], undefined, undefined, 2);
        } 

        super.onBigWinAnimationComplete();
        this.scene.sceneTextFields.get("win").text = "";
    }

    skip() {
        
        const elapsedSeconds = (new Date().getTime() - (<any>this.stateMachine.currentState).timer) / 1000;
        
        if(elapsedSeconds <= ConfigManager.getConfig<IFantasmaConfig>(ConfigurationTypes.GAME).minWatchTime) {
            return;
        }

        super.skip();
        
        if(this.bigWinAnimDelayed) {
            this.bigWinAnimDelayed.kill();
        }
        if(!this.bigWinAnimComplete) {
            this.onBigWinAnimationComplete();
        }
    }

    private playAnimation(
        animName: string,
        loop?: boolean,
        timeScale?: number): Promise<boolean> 
    {
        return new Promise((res) => {
            this.anim.play(animName);
            Tween.delayedCall(this.anim.getAnimDuration(animName), () => {
                res();
            }, [], this);
        });
    }

    protected async onBigWinComplete() {
        await this.anim.playAsync(this.bwNames[this.maxBigWinLevel].replace("_loop", "_end"));
        if (SpinModel.featureMode != -1) {
            // Sebastian want to stop reels win blinking light after 0.5 sec. 
            Tween.delayedCall(0.5, () => {
                if (SpinModel.featureMode == 1) {
                    BackgroundHelper.backgrounBN1Loop();
                } else {
                    BackgroundHelper.backgrounBN2Loop();
                }
            });
        }
        super.onBigWinComplete();
        ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
    }
}